module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', _vm._b({
    attrs: {
      "fullscreen": _vm.$dayspan.fullscreenDialogs
    },
    model: {
      value: (_vm.open),
      callback: function($$v) {
        _vm.open = $$v
      },
      expression: "open"
    }
  }, 'v-dialog', _vm.dialogProps, false), [(_vm.schedule && _vm.details) ? _c('v-card', [_c('v-card-text', [_c('ds-event', _vm._b({
    attrs: {
      "target-details": _vm.details,
      "target-schedule": _vm.schedule,
      "calendar": _vm.calendar,
      "calendar-event": _vm.calendarEvent,
      "day": _vm.day,
      "read-only": _vm.readOnly
    },
    on: {
      "saved": _vm.saved,
      "cancel": _vm.cancel,
      "actioned": _vm.actioned,
      "event-create": _vm.eventCreate,
      "event-update": _vm.eventUpdate,
      "event-remove": _vm.eventRemove
    }
  }, 'ds-event', {
    $scopedSlots: _vm.$scopedSlots
  }, false))], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ee85dea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EventDialog.vue
// module id = 173
// module chunks = 0